import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PulseLoader } from 'react-spinners';
import classnames from 'classnames';
import Link from '../Link/Link';
import T from 'prop-types';

const LinkButton = ({
  children,
  className,
  disabled,
  loading,
  tooltipProps: { placement = 'bottom', text = '' } = {},
  ...rest
}) => {
  const link = (
    <Link
      className={classnames(className, { disabled })}
      {...rest}
      to={rest?.to || ''}
    >
      {loading ? <PulseLoader color='#fff' size={12} /> : children}
    </Link>
  );

  if (!text) {
    return link;
  }

  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: 250 }}
      overlay={<Tooltip>{text}</Tooltip>}
    >
      {link}
    </OverlayTrigger>
  );
};

LinkButton.propTypes = {
  children: T.node,
  className: T.string,
  disabled: T.bool,
  loading: T.bool,
  tooltipProps: T.shape({
    placement: T.string,
    text: T.string,
  }),
};

export default LinkButton;
